/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const AIGenerateBrandedNewIcon = /*#__PURE__*/ createSvgIcon(
  'AIGenerateBrandedNewIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M8.766 4.552C8.932 4.146 9.506 4.146 9.672 4.552L10.568 6.751C11.065 7.968 12.032 8.935 13.250 9.430L15.448 10.328C15.853 10.494 15.853 11.069 15.448 11.236L13.250 12.131C12.032 12.628 11.065 13.595 10.568 14.813L9.672 17.011C9.506 17.417 8.932 17.417 8.766 17.011L7.875 14.813C7.377 13.595 6.403 12.628 5.190 12.131L2.990 11.236C2.583 11.069 2.583 10.494 2.990 10.328L5.190 9.430C6.403 8.935 7.377 7.968 7.875 6.751L8.766 4.552Z"
            fill={`url(#${id}_0)`}
          />
          <path
            d="M14.414 3.226C14.506 3.000 14.826 3.000 14.918 3.226L15.312 4.189C15.404 4.416 15.583 4.596 15.809 4.688L16.773 5.081C16.999 5.173 16.999 5.493 16.773 5.585L15.809 5.979C15.583 6.072 15.404 6.250 15.312 6.478L14.918 7.440C14.826 7.666 14.506 7.666 14.414 7.440L14.020 6.478C13.928 6.250 13.749 6.072 13.523 5.979L12.559 5.585C12.333 5.493 12.333 5.173 12.559 5.081L13.523 4.688C13.749 4.596 13.928 4.416 14.020 4.189L14.414 3.226Z"
            fill={`url(#${id}_1)`}
          />
          <defs>
            <radialGradient
              id={`${id}_0`}
              cx={0}
              cy={0}
              r={1}
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(2.379 3.941) rotate(45) scale(18.917 17.211)"
            >
              <stop stopColor="#6923DE" />
              <stop offset={1} stopColor="#3286FF" />
            </radialGradient>
            <radialGradient
              id={`${id}_1`}
              cx={0}
              cy={0}
              r={1}
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(12.283 2.950) rotate(45) scale(6.591 5.996)"
            >
              <stop stopColor="#6923DE" />
              <stop offset={1} stopColor="#3286FF" />
            </radialGradient>
          </defs>
        </>
      ),
    },
  },
  false
);

export default AIGenerateBrandedNewIcon;
